import React, { useState, useRef, useEffect, useContext } from "react";
import {
    IconButton, Badge, Tooltip, Popper, Box, Paper, List, ListItem, ListItemText, ClickAwayListener, Typography, TextField,
} from "@mui/material";
import { URL } from "../../common/api/urls";
import { useAxiosWithAuth } from "../../common/api/hooks/useAxiosWithAuth";
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from "@mui/icons-material/Refresh";
import { NOTIFICATION_POLLING_INTERVAL } from "../../common/utility/constant";
import { UserSettingsContext } from "../../setup/routes-manager/RequireAuth";
import { requestNotificationPermission } from "../../firebase";



const NotificationComponent = ({ onNoticationClick }) => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null); // Reference to IconButton
    const [cancel, responseData, error, loaded, reset, executeAPI] = useAxiosWithAuth();
    const [cancelSettings, responseDataSettings, errorSettings, loadedSettings, resetSettings, executeAPISettings] = useAxiosWithAuth();
    const [cancelToken,responseDataToken, errorToken, loadedToken, resetToken,executeAPIToken ] = useAxiosWithAuth();
    const [notificationList, setNotificationList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [search, setSearch] = useState('');
    const [hasUnread, setHasUnread] = useState(
        localStorage.getItem('hasUnreadNotifications') === 'true'
    );
    const { userSettings, setUserSettings } = useContext(UserSettingsContext);




    useEffect(() => {
        executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
        const handleServiceWorkerMessage = (event) => {
            console.log("FCM Message received from SW:", event);
            //   if (event.data?.type === 'NEW_NOTIFICATION') {
            console.log("FCM service worker Background message received in app", event.data.payload, hasUnread);
            localStorage.setItem('hasUnreadNotifications', 'true');
            setHasUnread(true);
            //   }
        };

        const handleStorageChange = () => {
            setHasUnread(localStorage.getItem('hasUnreadNotifications') === 'true');
        };


        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
        }

        window.addEventListener('storage', handleStorageChange);
        // Cleanup function to remove the event listener
        return () => {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
            }
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    //polling notifications
    useEffect(()=>{
        if(open)
            executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
        
        const refreshInterval = setInterval(() => {
           
            if(open){
                console.log("Calling polling notigication api")
                executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
            }            
        
        }, NOTIFICATION_POLLING_INTERVAL);
        return () => {
            clearInterval(refreshInterval);
          };
    },[open]);


    useEffect(() => {
        console.log("FCM hasunread=", hasUnread)
        if (hasUnread)
            executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
    }, [hasUnread]);



    //api response handler
    useEffect(() => {
        if (loaded) {
            // console.log("Bookmark list ========>",responseData.data);
            if (responseData != null) {
                let data = responseData.data ? responseData.data : [];
                setNotificationList(data);
                if (search) {
                    let temp = data.filter(item =>
                        item.toLowerCase().includes(search)

                    );
                    setFilteredList(temp);

                } else {
                    setFilteredList(data)
                }


            } else if (error !== null) {
                console.log("Error data=", error);
                // setMsgState({open:true,msg:errorAutoSave?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
                if (error?.response?.status === 401 || error?.response?.status === 403) {
                    console.log("status received =", error?.response?.status)
                    //   navigate(from, { replace: true });
                } else {
                    //   setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
                }
            }
            reset();

        }

    }, [loaded, responseData])

    useEffect(() => {
        if (!loadedSettings) {
            return;
        }
        if (responseDataSettings != null) {
            const { send_sample_notification: _sendSampleNotification, ...settingsData } = responseDataSettings.data || {};
            const nextSettings = {
                ...responseDataSettings,
                data: {
                    ...settingsData,
                    browser_push_notifications: true,
                },
            };
            setUserSettings(nextSettings);

            async function saveFCMToken() {
                let fcmToken = null;
                try {
                    fcmToken = await requestNotificationPermission();
                } catch (err) {
                    console.warn("FCM token not retrieved. User may have denied notifications.");
                }
                if (fcmToken) {
                    executeAPIToken(URL.SAVE_FCM_TOKEN, "POST", { 
                        fcm_token: fcmToken,
                        send_sample_notification: true 
                    });
                }
            }
            saveFCMToken();
        } else if (errorSettings !== null) {
            console.log("Error enabling push notifications=", errorSettings);
        }
        resetSettings();
    }, [loadedSettings, responseDataSettings, errorSettings]);

    const handleToggle = () => {
        setSearch('');
        setOpen(true);
        // setOpen((prev) => !prev);
        localStorage.setItem('hasUnreadNotifications', 'false');
        setHasUnread(false);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };



    const openNotification = (event, item) => {
        // setOpen(false);

    }
    const handleSearchChange = (e) => {

        setSearch(e.target.value.toLowerCase());


    };

    useEffect(() => {
        console.log("search= 1", search)
        if (search) {
            let temp = notificationList.filter(item =>
                item.toLowerCase().includes(search)

            );
            setFilteredList(temp);
            console.log("search= 2 ", search, temp)
        } else {
            setFilteredList(notificationList)
        }
    }, [search])

    const handleRefresh = () => {
        executeAPI(URL.GET_USER_NOTIFICATIONS, "GET", {})
    };

    const handleEnablePushNotifications = () => {
        if (!userSettings?.data) {
            return;
        }
        const { send_sample_notification: _sendSampleNotification, ...settingsData } = userSettings.data;
        executeAPISettings(URL.UPDATE_USER_SETTING, "POST", {
            ...settingsData,
            browser_push_notifications: true,
        });
    };

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleToggle}
                sx={{ mr: 1 }}
                size="small"
                edge="start"
                aria-label="bookmark"
            >
                <Tooltip title="Notification">
                    {/* <NotificationsIcon sx={{ color: "primaryTheme.shade01", width: "24px", height: "24px" }} /> */}
                    <Badge
                        color="warning"
                        variant="dot"
                        invisible={!hasUnread} // dynamically toggle this
                        sx={{
                            "& .MuiBadge-dot": {
                                backgroundColor: "#FF5733", // Custom color
                            },
                        }}
                    >
                        <NotificationsIcon
                            sx={{ color: "primaryTheme.shade01", width: "24px", height: "24px" }}
                        />
                    </Badge>
                </Tooltip>
            </IconButton>

            {/* Popper for showing the list below the button */}
            {/* <Popper open={open} anchorEl={anchorRef.current} placement="bottom-start" style={{ zIndex: 1300,mr:-8 }}> */}
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement="bottom-end"
                style={{ zIndex: 1300, transform: "translateX(-20px)" }} // Moves it 20px left
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper
                        elevation={3}
                        sx={{
                            pl: 1,
                            pr: 1,
                            pb: 1,
                            // width:400,
                            minWidth: 420,
                            maxWidth: 500,
                            maxHeight: 500,  // Limit height to 400px
                            overflowY: "auto" // Enable scrolling when content overflows
                        }}
                    >
                      
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                mt: 1,
                                mb: 1
                            }}
                        >
                            <TextField
                                variant="outlined"
                                size="small"
                                fullWidth
                                placeholder="Search notifications"
                                onChange={handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <SearchIcon fontSize="small" sx={{ mr: 1, ml: 1 }} />
                                    )
                                }}
                            />
                            <Tooltip title="Enable browser notifications. Make sure your device settings allow for sending push notifications on this browser.">
                                <IconButton onClick={handleEnablePushNotifications} sx={{ ml: 1, mr: -0.5 }} aria-label="Enable browser notifications. Make sure your device settings allow for sending push notifications on this browser.">
                                    <NotificationsActiveIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Fetch latest notifications and update the list below.">
                            <IconButton onClick={handleRefresh} sx={{ ml: 0 }}>
                                <RefreshIcon />
                            </IconButton>
                            </Tooltip>
                        </Box>
                        <Typography sx={{ fontSize: "12px", fontStyle:"italic", color:"#f6b0b0" }}>&nbsp;&nbsp;&nbsp;&nbsp; *add instruments to watchlist to get any available alerts</Typography>
                        <Typography sx={{ fontSize: "12px", fontStyle:"italic", color:"#f6b0b0" }}>&nbsp;&nbsp;&nbsp;&nbsp; *enable notifications for this browser to receive alerts on this device</Typography>
                        <List>
                            {/* <Divider /> Adds a separator */}
                            {filteredList.length > 0 ? (
                                filteredList.map((item) => (
                                    <ListItem button key={item} onClick={(event) => openNotification(event, item)}>
                                        <ListItemText primary={
                                            <Typography variant="body2" sx={{ fontSize: "12px" }}>
                                                {item}
                                            </Typography>
                                        } />
                                    </ListItem>
                                ))
                            )
                                : (
                                    <></>
                                    // <ListItem>
                                    //     {/* <ListItemText primary="No notification available" /> */}
                                    // </ListItem>
                                )
                            }
                        </List>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export default NotificationComponent;
